// extracted by mini-css-extract-plugin
export var description = "ConsentModal-module--description--6c88b";
export var button = "ConsentModal-module--button--92a04";